import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for a plain JavaScript date
 * Serialized format is an ISO string
 */
export const dateSerializer = CreateSerializer(serializeDate, deserializeDate);
function serializeDate(value) {
    return value.toISOString();
}
function deserializeDate(value) {
    return new Date(value);
}
